<template>
  <button
    :type="type"
    v-bind="$attrs"
    :disabled="isLoading || disabled"
    class="button"
    :class="bgColor"
  >
    <Transition> <AppLoading v-if="isLoading" /> </Transition><slot />
  </button>
</template>

<script setup lang="ts">
const { type = 'button', bgColor = 'gray-bg' } = defineProps<{
  type?: 'button' | 'submit'
  isLoading?: boolean
  disabled?: boolean
  bgColor?: 'gray-light' | 'graybg'
}>()
</script>

<style lang="scss" scoped>
.button {
  gap: 8px;
  @include button;

  & {
    color: $black100;
  }

  &.gray-light {
    background-color: $greyLight;
  }

  &.gray-bg {
    background-color: $bgGrey;
  }

  :deep(.loader__spinner) {
    width: 20px;
    height: 20px;
    border-color: $black100;
    border-bottom-color: transparent;
  }
}
</style>
